import React, { VFC, useRef, useCallback, useEffect } from 'react';
import classnames from 'classnames';

import Button from '../common/Button/Button';

import styles from './LinksDropdown.module.scss';
import NavigationLinks from './NavigationLinks';

interface LinksDropdownProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  buttonClassName: string;
  dropdownClassName: string;
}

const LinksDropdown: VFC<LinksDropdownProps> = ({
  isOpen,
  setIsOpen,
  buttonClassName,
  dropdownClassName,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleIsOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen]);

  const closeDropdown = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleClickOutsideContainer = useCallback(
    (_target: EventTarget | null) => {
      if (
        containerRef.current &&
        // @ts-ignore
        !containerRef.current.contains(_target)
      ) {
        setIsOpen(false);
      }
    },
    [setIsOpen],
  );

  useEffect(() => {
    document.addEventListener('mousedown', (ev) => handleClickOutsideContainer(ev.target));

    return document.removeEventListener('mousedown', (ev) =>
      handleClickOutsideContainer(ev.target),
    );
  }, [handleClickOutsideContainer]);

  return (
    <div ref={containerRef}>
      <Button
        className={classnames(buttonClassName, styles.hamburgerMenuButton)}
        onClick={toggleIsOpen}
      >
        <img src={isOpen ? '/icons/CloseIcon.svg' : '/icons/HamburgerIcon.svg'} alt="" />
      </Button>

      {isOpen && (
        <div className={classnames(dropdownClassName, styles.linksDropdown)}>
          <NavigationLinks inDropdown clickSideEffect={closeDropdown} />
        </div>
      )}
    </div>
  );
};

export default LinksDropdown;
